function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_white_unknown",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("g", {
  id: "assets/icons/ic_unknown",
  transform: "translate(4.000000, 2.000000)"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 40,
  height: 24
}), React.createElement("path", {
  d: "M20.835141,14.5 L20.835141,13.8803419 C20.835141,13.6096866 20.8640636,13.3710826 20.9219089,13.1645299 C20.9797542,12.9579772 21.1135213,12.7336182 21.3232104,12.491453 C21.5328995,12.2492877 21.977585,11.957265 22.6572668,11.6153846 C23.4671005,11.2165242 24.0600145,10.764245 24.4360087,10.258547 C24.8120029,9.752849 25,9.12250712 25,8.36752137 C25,7.27065527 24.5480839,6.35185185 23.6442516,5.61111111 C22.7404194,4.87037037 21.5184382,4.5 19.978308,4.5 C18.4381779,4.5 17.241504,4.87393162 16.3882863,5.62179487 C15.5350687,6.36965812 15.0723066,7.36324786 15,8.6025641 L15,8.6025641 L17.6681128,8.6025641 C17.7259581,8.06125356 17.9573391,7.62321937 18.362256,7.28846154 C18.7671728,6.9537037 19.3239335,6.78632479 20.032538,6.78632479 C20.7411424,6.78632479 21.2762111,6.93233618 21.637744,7.22435897 C21.9992769,7.51638177 22.1800434,7.87962963 22.1800434,8.31410256 C22.1800434,8.7485755 22.0607375,9.10470085 21.8221258,9.38247863 C21.5835141,9.66025641 21.1966739,9.93447293 20.6616052,10.2051282 C20.1265365,10.4757835 19.7216197,10.7108262 19.4468547,10.9102564 C18.6659436,11.451567 18.2754881,12.3632479 18.2754881,13.6452991 L18.2754881,13.6452991 L18.2754881,14.5 L20.835141,14.5 Z M19.4728916,19.5 C19.9126506,19.5 20.2771084,19.3566879 20.5662651,19.0700637 C20.8554217,18.7834395 21,18.4235669 21,17.9904459 C21,17.5573248 20.8554217,17.2006369 20.5662651,16.9203822 C20.2771084,16.6401274 19.9126506,16.5 19.4728916,16.5 C19.0331325,16.5 18.6777108,16.6401274 18.4066265,16.9203822 C18.1355422,17.2006369 18,17.5573248 18,17.9904459 C18,18.4235669 18.1355422,18.7834395 18.4066265,19.0700637 C18.6777108,19.3566879 19.0331325,19.5 19.4728916,19.5 Z",
  id: "?",
  fill: "#878787",
  fillRule: "evenodd"
})));

const SvgIcWhiteBadgeUnknown = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcWhiteBadgeUnknown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_white_badge_unknown.b3062450.svg";
export { ForwardRef as ReactComponent };